module.exports = __webpack_public_path__ + "img/construction_project_splash.c4346340.jpg";